// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1ZoecMzuO74wRP81CG0Y{min-height:unset;max-height:unset;height:100%}._1ZoecMzuO74wRP81CG0Y .RRbziaKBpq2hMiUXWSTy{overflow:hidden}`, "",{"version":3,"sources":["webpack://./services/client/src/components/dashboardGraphs/IssuesNumbers/components/IssuesFixed/styles.module.scss"],"names":[],"mappings":"AAAA,uBACE,gBAAA,CACE,gBAAA,CACA,WAAA,CACF,6CACE,eAAA","sourcesContent":[".grid {\n  min-height: unset;\n    max-height: unset;\n    height: 100%;\n  .column {\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `_1ZoecMzuO74wRP81CG0Y`,
	"column": `RRbziaKBpq2hMiUXWSTy`
};
export default ___CSS_LOADER_EXPORT___;
